import { useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";

import { Box, Stack, Typography, IconButton } from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";

import SurveyEntry_SectionText from "./SurveyEntry_SectionText";
import SurveyEntry_SectionQuestion from "./SurveyEntry_SectionQuestion";
import SurveyEntry_SectionMatrix from "./SurveyEntry_SectionMatrix";
import SurveyEntry_Variability from "./SurveyEntry_Variability";
import SurveyEntry_SkuMatrix from "./SurveyEntry_SkuMatrix";
import DescriptionDisplay from "./DescriptionDisplay";

import SkuMatrixStatus from "./SkuMatrixStatus";
import QuestionSectionStatus from "./QuestionSectionStatus";

const SurveyEntry_Section = ({
  callResultId,
  section,
  questions,
  answers,
  call,
  location,
  onChange,
  onNextSection,
  onPrevSection,
  allowPrev,
  allowNext,
  isDisabled,
  testMode = false,
}) => {
  const theme = useTheme();

  return (
    <Stack>
      <Box
        sx={{
          paddingLeft: "4px",
          backgroundColor: theme.palette.primary.light,
          position: "sticky",
          top: 30,
          zIndex: 250,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "4px",
            paddingBottom: "4px",
            paddingRight: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ArrowCircleLeftIcon
              onClick={onPrevSection}
              color="black"
              sx={{ cursor: "pointer", opacity: allowPrev() ? 1 : 0.1 }}
            />
            <Box sx={{ display: "flex" }}>
              {section.sectionType === "sku" && (
                <SkuMatrixStatus
                  section={section}
                  questions={questions}
                  answers={answers}
                  location={location}
                  call={call}
                />
              )}
              {section.sectionType === "question" && (
                <QuestionSectionStatus
                  section={section}
                  questions={questions}
                  answers={answers}
                  location={location}
                />
              )}
              <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
                {section.name}
              </Typography>
            </Box>
          </Box>
          <ArrowCircleRightIcon
            onClick={onNextSection}
            color="black"
            sx={{ cursor: "pointer", opacity: allowNext() ? 1 : 0.1 }}
          />
        </Box>
      </Box>

      <DescriptionDisplay item={section} />

      {section.variability && (
        <Box>
          <SurveyEntry_Variability
            section={section}
            call={call}
          />
        </Box>
      )}

      {section.sectionType === "text" ? (
        <SurveyEntry_SectionText section={section} />
      ) : null}

      {section.sectionType === "question" ? (
        <SurveyEntry_SectionQuestion
          callResultId={callResultId}
          section={section}
          questions={questions}
          answers={answers}
          call={call}
          location={location}
          onChange={onChange}
          isDisabled={isDisabled}
          testMode={testMode}
        />
      ) : null}

      {section.sectionType === "matrix" ? (
        <SurveyEntry_SectionMatrix
          callResultId={callResultId}
          section={section}
          questions={questions}
          answers={answers}
          call={call}
          location={location}
          onChange={onChange}
          isDisabled={isDisabled}
          testMode={testMode}
        />
      ) : null}

      {section.sectionType === "sku" ? (
        <SurveyEntry_SkuMatrix
          callResultId={callResultId}
          section={section}
          questions={questions}
          answers={answers}
          call={call}
          location={location}
          onChange={onChange}
          isDisabled={isDisabled}
          testMode={testMode}
        />
      ) : null}
    </Stack>
  );
};

export default SurveyEntry_Section;
